import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const ExportIcon = styled.a`
    ${BaseStyle.Mixins.fontStyles.ui['14m']};
    ${BaseStyle.Mixins.gaps.extraSmall};
    cursor: pointer;
    display: none;
    justify-content: end;
    margin-left: auto;
    padding-top: 6px;

    && {
        color: ${({ theme }) => theme.Utility.cta};

        svg path {
            color: ${({ theme }) => theme.Utility.cta};
        }
    }

    ${BaseStyle.Mixins.screenSizes.large} {
        display: flex;
    }
`;
